// cart-icon-counter.js — force unified cart count
(function () {
  function updateCounters(cart) {
    const qty = cart?.totalQuantity || 0;

    // Force update Shopify cart bubble
    document.querySelectorAll("#cart-icon-bubble .cart-bubble").forEach((bubble) => {
      const textEl = bubble.querySelector(".cart-bubble__text-count");
      const srEl = bubble.querySelector(".visually-hidden");

      if (textEl) {
        textEl.textContent = qty;
        textEl.classList.toggle("hidden", qty === 0);
      }
      if (bubble) {
        bubble.classList.toggle("visually-hidden", qty === 0);
      }
      if (srEl) {
        srEl.textContent = `Total items in cart: ${qty}`;
      }
    });

    // Fallback legacy selectors
    document.querySelectorAll("[data-cart-count], .cart-count").forEach((el) => {
      el.textContent = qty;
      el.classList.toggle("is-empty", qty === 0);
    });

    console.log("[UnifiedCart][Counter] set to", qty);
  }

  async function refreshCounters() {
    if (!window.PBCart) return;
    try {
      const cart = await window.PBCart.refresh();
      updateCounters(cart);
    } catch (err) {
      console.warn("[CartCounter] refresh failed", err);
    }
  }

  // Listen for unified cart updates
  document.addEventListener("pb:cart:updated", (e) => updateCounters(e.detail.cart));

  // Initial sync
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshCounters);
  } else {
    refreshCounters();
  }
})();
